import React, { useContext } from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext from '../../contexts/language';
import { FiMapPin, FiPhoneCall } from "react-icons/fi";

import hotel_1 from '../../assets/images/hotel_1.jpg';
import hotel_2 from '../../assets/images/hotel_2.jpg';
import hotel_3 from '../../assets/images/hotel_3.jpg';
import hotel_4 from '../../assets/images/hotel_4.jpg';

export default function Hotel() {

    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');


    return (
        <div className="page">
            <Header fundo="green" />
            <div className="content">
                <div className="full mt-30 mb-40 text-center form">
                    <h3 className="title_b color_3 mt-30 mb-20">
                        {language.menu_local}
                    </h3>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 hotel-content">
                                <div className="row space-hotel">
                                    <div className="col-md-3">
                                        <img src={hotel_1} className="img-fluid rounded" />
                                    </div>
                                    <div className="col-md-9 text">
                                        <h4 className="mb-10"><strong>Pullman São Paulo Vila Olímpia</strong></h4>
                                        <div className="hotel-infos mb-30">
                                            <div><em>Pullman São Paulo Vila Olímpia</em></div>
                                            <div><FiMapPin color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.address}:</strong> Rua Olimpíadas, 205, São Paulo, Brasil, CEP 04551-000.</div>
                                            <div><FiPhoneCall color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.phone}:</strong> +55 (11) 3049-6622</div>
                                        </div>
                                        <a href="https://www.pullmanvilaolimpia.com" target="_blank" className="btn-send bg_color_3">{language.access_hotel}</a>
                                    </div>
                                </div>
                                <div className="row space-hotel">
                                    <div className="col-md-3">
                                        <img src={hotel_2} className="img-fluid rounded" />
                                    </div>
                                    <div className="col-md-9 text">
                                        <h4 className="mb-10"><strong>Grand Mercure Vila Olímpia</strong></h4>
                                        <div className="hotel-infos mb-30">
                                            <div><em>Grand Mercure São Paulo Vila Olímpia</em></div>
                                            <div><FiMapPin color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.address}:</strong> Rua Olimpíadas, 205, São Paulo, Brasil, CEP 04551-000.</div>
                                            <div><FiPhoneCall color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.phone}:</strong> +55 (11) 2161-4900</div>
                                        </div>
                                        <a href="https://all.accor.com/hotel/8942/index.pt-br.shtml" target="_blank" className="btn-send bg_color_3">{language.access_hotel}</a>
                                    </div>
                                </div>
                                <div className="row space-hotel">
                                    <div className="col-md-3">
                                        <img src={hotel_3} className="img-fluid rounded" />
                                    </div>
                                    <div className="col-md-9 text">
                                        <h4 className="mb-10"><strong>Hotel Estanplaza</strong></h4>
                                        <div className="hotel-infos mb-30">
                                            <div><em>Estanplaza Funchal Faria Lima</em></div>
                                            <div><FiMapPin color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.address}:</strong> Rua Funchal, 281, Vila Olímpia, São Paulo, SP, Brasil.</div>
                                            <div><FiPhoneCall color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.phone}:</strong> +55 (11) 3897-7500</div>
                                        </div>
                                        <a href="https://www.estanplaza.com.br" target="_blank" className="btn-send bg_color_3">{language.access_hotel}</a>
                                    </div>
                                </div>
                                <div className="row space-hotel">
                                    <div className="col-md-3">
                                        <img src={hotel_4} className="img-fluid rounded" />
                                    </div>
                                    <div className="col-md-9 text">
                                        <h4 className="mb-10"><strong>The World You Stay At Vila Olímpia</strong></h4>
                                        <div className="hotel-infos mb-30">
                                            <div><em>The World Hotels - Vila Olímpia</em></div>
                                            <div><FiMapPin color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.address}:</strong> Rua Gomes de Carvalho, 1005, Vila Olímpia, São Paulo/SP, CEP 04547-002.</div>
                                            <div><FiPhoneCall color="#034992" size={26} style={{marginRight: 4}} /> <strong>{language.phone}:</strong> +55 (11) 3049-6700</div>
                                        </div>
                                        <a href="https://vilaolimpia.theworld.com.br/" target="_blank" className="btn-send bg_color_3">{language.access_hotel}</a>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
